export default "__VITE_ASSET__CY0PFlXP__"